export default __webpack_public_path__ + "static/media/schedule.3d35c81d.svg";